__turbopack_context__.v({
  "container": "header-module-scss-module__IdiWQW__container",
  "left-section": "header-module-scss-module__IdiWQW__left-section",
  "logo": "header-module-scss-module__IdiWQW__logo",
  "need-help-container": "header-module-scss-module__IdiWQW__need-help-container",
  "top-bar": "header-module-scss-module__IdiWQW__top-bar",
});
